// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import grmoutEntity from './entities/grmout.json';
import grmoutMenu from '../pages/grmout/menu.json';
import grmoutFullForm from '../pages/grmout/forms/full.json';
import grmoutContextForm from '../pages/grmout/forms/context.json';
import grmoutMiniForm from '../pages/grmout/forms/mini.json';
import grmoutLookupForm from '../pages/grmout/forms/lookup.json';
import grmoutTableView from '../pages/grmout/views/table.json';
import grmoutStagesView from '../pages/grmout/views/stages.json';
import grmoutCardsView from '../pages/grmout/views/cards.json';
import grmoutInlineView from '../pages/grmout/views/inline.json';
import grmoutBacklogView from '../pages/grmout/views/backlog.json';
import grmoutSplitView from '../pages/grmout/views/split.json';
import grmoutCalendarView from '../pages/grmout/views/calendar.json';
import grmoutDashboardView from '../pages/grmout/views/dashboard.json';

/** Тип запису «Запит до органу» зі сторінками пакета: меню, форми та подання з pages/grmout/. */
export const grmoutDefinition: IRecordTypeDefinition = {
  ...grmoutEntity,
  views: assembleViewSet({
      table: grmoutTableView,
      stages: grmoutStagesView,
      cards: grmoutCardsView,
      inline: grmoutInlineView,
      backlog: grmoutBacklogView,
      split: grmoutSplitView,
      calendar: grmoutCalendarView,
      dashboard: grmoutDashboardView,
  }),
  form: grmoutFullForm,
  forms: { full: grmoutFullForm, context: grmoutContextForm, mini: grmoutMiniForm, lookup: grmoutLookupForm },
  menu: grmoutMenu,
} as IRecordTypeDefinition;
